module.exports = __webpack_public_path__ + "media/images/blue_logo-a9ce16d0a4390dfb7258339290f368dc16524ad5306c62fb0b9ba0163bc0ba49.png";